import gql from "graphql-tag";

export const getOdeUpdateWithComments = gql`
  query GetOdeUpdateWithComments(
    $id: ID!
  ){
    odeUpdate(
      where: { id: $id }
    ) {
      id
      comments {
        id
        comment
        edited
        author {
          id
          fullName
          firstName
          middleName
          lastName
          profilePicUrl
        }
        createdAt
        updatedAt
      }
    }
  }
`;
